'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _unsubscribe = require('../../actions/unsubscribe');

var _Unsubscribe = require('../../components/Unsubscribe');

var _Unsubscribe2 = _interopRequireDefault(_Unsubscribe);

var _unsubscribe2 = require('../../helpers/unsubscribe');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unsubscribeScope = function unsubscribeScope(s) {
  if (!s || !s.length) {
    return _unsubscribe2.Scope.abandonedCartReminder;
  }

  if (s in _unsubscribe2.Scope) {
    return s;
  }

  // throw new Error(`Unrecognized unsubscribe scope '${s}'`)

  return _unsubscribe2.Scope.abandonedCartReminder;
};

var UnsubscribeContainer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(UnsubscribeContainer, _Component);

  function UnsubscribeContainer() {
    (0, _classCallCheck3.default)(this, UnsubscribeContainer);
    return (0, _possibleConstructorReturn3.default)(this, (UnsubscribeContainer.__proto__ || (0, _getPrototypeOf2.default)(UnsubscribeContainer)).apply(this, arguments));
  }

  (0, _createClass3.default)(UnsubscribeContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var token = this.props.location.query.token;
      var scope = unsubscribeScope(this.props.location.query.scope);

      if (token) {
        this.props.unsubscribeAction(token, scope);
      } else {
        this.props.dispatch({
          type: 'UNSUBSCRIBE_FAILURE',
          error: 'Token parameter is required.'
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_Unsubscribe2.default, { unsubscribe: this.props.unsubscribe });
    }
  }]);
  return UnsubscribeContainer;
}(_react.Component), _class.propTypes = {
  location: _propTypes2.default.object.isRequired,
  params: _propTypes2.default.object.isRequired,
  unsubscribeAction: _propTypes2.default.func.isRequired,
  unsubscribe: _propTypes2.default.object
}, _temp);


var mapStateToProps = function mapStateToProps(state) {
  return {
    unsubscribe: state.unsubscriber
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    unsubscribeAction: function unsubscribeAction(token, scope) {
      return dispatch((0, _unsubscribe.unsubscribe)(token, scope));
    },
    dispatch: dispatch
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(UnsubscribeContainer);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/UnsubscribeContainer/index.js
// module id = 2514
// module chunks = 0